import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const PricingCard = ({
  plan,
  billingCycle,
  isRecommended,
  onSelectPlan
}) => {
  const price =
    billingCycle === "monthly"
      ? plan.monthlyPrice
      : plan.annualPrice;

  return (
    <div
      className={`relative bg-card rounded-xl border shadow-sm p-6 flex flex-col
        ${isRecommended ? "border-primary shadow-lg" : "border-border"}
      `}
    >
      {isRecommended && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground text-xs px-3 py-1 rounded-full">
          Most Popular
        </span>
      )}

      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <Icon name={plan.icon} size={28} />
        <div>
          <h3 className="text-xl font-bold">{plan.name}</h3>
          <p className="text-sm text-muted-foreground">
            {plan.description}
          </p>
        </div>
      </div>

      {/* Price */}
      <div className="my-4">
        <div className="text-4xl font-bold">
          {price === 0 ? "Free" : `$${price}`}
          {price !== 0 && (
            <span className="text-base text-muted-foreground"> /mo</span>
          )}
        </div>

        {plan.trialDays > 0 && (
          <p className="text-sm text-success mt-1">
            {plan.trialDays}-day free trial
          </p>
        )}
      </div>

      {/* Features */}
      <ul className="space-y-2 flex-1">
        {plan.features.map((feature, index) => (
          <li key={index} className="flex items-center gap-2">
            {feature.included ? (
              <Icon name="CheckCircle" size={18} color="var(--color-success)" />
            ) : (
              <Icon name="XCircle" size={18} color="var(--color-muted-foreground)" />
            )}
            <span
              className={
                feature.included
                  ? "text-foreground"
                  : "text-muted-foreground"
              }
            >
              {feature.text}
            </span>
          </li>
        ))}
      </ul>

      {/* CTA */}
      <Button
        className="mt-6"
        variant={isRecommended ? "default" : "outline"}
        onClick={() => onSelectPlan(plan)}
      >
        {plan.ctaText}
      </Button>
    </div>
  );
};

export default PricingCard;
